module.exports = function() {
  return new Worker(__webpack_public_path__ + "cfe5618d66fbf638c1bd.worker.js");
};